<template>
  <transition name="fade">
    <img v-lazy="src" v-on:load="onLoaded" v-show="isLoaded">&nbsp;
  </transition>
</template>

<script>

  export default {
    name: 'vImage',
    props: ['src'],
    data: function() {
      return {
        loaded: false,
      }
    },
    methods: {
      onLoaded() {
        this.loaded = true
      }
    },
    computed: {
      isLoaded() {
        return this.loaded === true
      }
    }
  }

</script>

<style scoped lang="stylus">
  img
    /*transition opacity .5s ease-in-out*/
    width: 100%
  img[lazy='loading']
    opacity 0
  img[lazy='loaded']
    opacity 1
  img, .fade-enter-active
    transition opacity .5s ease-in-out

  .fade-enter-to
    opacity 1

  .fade-enter
    opacity 0
</style>
